/* eslint-disable */
import React from "react";
import { Commodities } from '../../../controls/Commodities';
import { useDictionary, useParameter } from "../../../shared";
import { dictionaryService } from "../../../dataFlow";
import { Skeleton } from "@material-ui/lab";
import { SLIDE_NUMBER } from "../constants";
import { orderBy } from "lodash";
import { HierarchyControl, HierarchyControlItem } from '../../../../basf-ui';

interface ControlItem extends HierarchyControlItem<number> {
    olapCommodity: number;
}


const BUSINESS_UNIT = 1;

export const CommoditiesControl: React.FC = () => {
    const [controlItems, setControlItems] = React.useState<ControlItem[]>([]);

    const [commodityDisplay, setCommodityDisplay] = useParameter<number | null>("@commodities_display");
    const [commodityValue, setCommodityValue] = useParameter<number | null>("@commodities");

    const [dictItems, , loading] = useDictionary(dictionaryService, "slides-commodities-display", undefined, {
        business_unit: BUSINESS_UNIT,
        slide: SLIDE_NUMBER,
    });

    React.useEffect(function updateControlItems() {
        if (dictItems) {
            const sortedDictItems = orderBy(dictItems, item => item.getValue<number>("order"));
            const nextControlItems = sortedDictItems.map<ControlItem>(dictItem => ({
                id: dictItem.getValue<number>('id')!,
                name: (dictItem.getValue("name") as any)[9] as string,
                parent: dictItem.getValue<number>("parent"),
                olapCommodity: Number(dictItem.getValue<number>("olap_commodity")),
                disabled: dictItems.some(x => x.getValue<number>('parent')?.toString() === dictItem.id),
            }));
            setControlItems(nextControlItems);

            const selectedCandidate = nextControlItems.find(e => e.olapCommodity === commodityValue);
            if (selectedCandidate) {
                if (selectedCandidate.id !== commodityDisplay) {
                    setCommodityDisplay(selectedCandidate.id);
                }
            } else {
                setCommodityDisplay(nextControlItems[0]?.id);
            }
        }
    }, [dictItems]);

    const handlerChange = React.useCallback(
        (value: number | undefined) => {
            if (value) {
                const selectedItem = controlItems.find((item) => item.id === value)!;
                setCommodityDisplay(value);
                setCommodityValue(selectedItem.olapCommodity);
            }
        },
        [controlItems],
    );

    return <HierarchyControl
        loading={loading}
        label="Commodity"
        value={commodityDisplay as number | undefined}
        onChange={handlerChange}
        items={controlItems}
    />
};
